export const emailStates = {
  enter_email: "enterEmail",
  check_email: "checkEmail",
}